import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: ['GT-America', '"Segoe UI"', 'Roboto'].join(','),
  },
  palette: {
    primary: {
      main: '#456BD9',
    },
    grey: {
      800: '#3E3E3E',
    },
  },
});

export default theme;
